import { createContext, useMemo, useState } from "react";

interface TimelineZoomProviderProps {
  initialZoom: number;
}

interface TimelineZoomState {
  zoom: number;
  setZoom: (zoom: number | ((prev: number) => number)) => void;
}

export const TimelineZoomContext = createContext<TimelineZoomState>({
  zoom: 1,
  setZoom: () => {},
});

type TimelineProviderProps = {
  children: React.ReactNode;
} & TimelineZoomProviderProps;

export const TimelineZoomProvider = ({
  children,
  initialZoom,
}: TimelineProviderProps) => {
  const [zoom, setZoom] = useState(initialZoom);

  const state = useMemo(
    () => ({
      zoom,
      setZoom,
    }),
    [zoom, setZoom]
  );

  return (
    <TimelineZoomContext.Provider value={state}>
      {children}
    </TimelineZoomContext.Provider>
  );
};
